import { gql } from "@apollo/client";

const SPECIAL_FRAGMENT = gql`
fragment specialFragment on Special {
  id
  name
  type
  redemptionLimit
  menuType
  emailConfiguration {
    description
    descriptionHtml
    subject
    heading
    enabled
  }
  scheduleConfiguration {
    startStamp
    endStamp
    days
    setEndDate
    endDate
    recurringStartTime
    recurringEndTime
  }
  menuDisplayConfiguration {
    name
    description
    image
  }
}
`;
export default SPECIAL_FRAGMENT;